module.exports = __webpack_public_path__ + "static/media/lock-open-alt.6e81dc8b.svg";